import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export type ConfirmDialogTone = 'neutral' | 'primary' | 'warn';

export type ConfirmDialogData = {
  title?: string;
  message?: string;
  confirmText?: string;
  cancelText?: string;
  tone?: ConfirmDialogTone;
  icon?: string;
  input?: {
    enabled: boolean;
    label?: string;
    placeholder?: string;
    value?: string;
  };
};

export type ConfirmDialogResult = {
  confirmed: boolean;
  value?: string;
};

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss']
})
export class ConfirmDialogComponent {
  inputValue = '';

  constructor(
    public dialogRef: MatDialogRef<ConfirmDialogComponent, ConfirmDialogResult>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData,
  ) {
    this.inputValue = data?.input?.value ?? '';
  }

  get title(): string {
    return this.data?.title || 'Confirmar ação';
  }

  get message(): string {
    return this.data?.message || 'Tem certeza que deseja continuar?';
  }

  get confirmText(): string {
    return this.data?.confirmText || 'Confirmar';
  }

  get cancelText(): string {
    return this.data?.cancelText || 'Cancelar';
  }

  get tone(): ConfirmDialogTone {
    return this.data?.tone || 'neutral';
  }

  get inputEnabled(): boolean {
    return Boolean(this.data?.input?.enabled);
  }

  get inputLabel(): string {
    return this.data?.input?.label || 'Observação (opcional)';
  }

  get inputPlaceholder(): string {
    return this.data?.input?.placeholder || '';
  }

  onCancel(): void {
    this.dialogRef.close({ confirmed: false });
  }

  onConfirm(): void {
    this.dialogRef.close({
      confirmed: true,
      ...(this.inputEnabled ? { value: this.inputValue } : {})
    });
  }
}
